import { useSelector } from 'react-redux';

import { IServiceResponse } from '@sravni/types/lib/sitesettings';

import { getSiteSettings } from '../store/selectors/sitesettings';

export function useSiteSettings(): IServiceResponse {
  return useSelector(getSiteSettings);
}
